import {
  Box,
  Button,
  CircularProgress,
  Grid,
  Typography
} from '@material-ui/core'
import { ConsultaField } from 'src/components/ConsultaField'
import Spacer from 'src/components/Spacer'
import { useDefaultGoBack } from 'src/hooks/useDefaultGoBack'
import { TipoContratacao } from 'src/modules/lotes/types'
import { formatEnumFromDB } from 'src/utils/formatEnum'
import { formatUsername } from 'src/utils/formatUsername'
import { formatCurrency, formatDate, formatTime } from 'src/utils/formatters'
import { useProgramacao } from '../hooks/useProgramacao'
import { LoteProgramacaoSnapshot } from '../types'
import { AutorizacaoCarregamento } from './autorizacao-carregamento/AutorizacaoCarregamento'
import { formatCategoriaTransportador } from '../util/formatCategoriaTransportador'
import { useState } from 'react'
import { apiSauceInstance } from 'src/services/api'
import snackbarStore from 'src/stores/snackbar'

import historicoIntegracaoStore from '../store/historico-integracao-store'
import { ModalHistoricoIntegracao } from './ModalHistoricoIntegracao'

export const ConsultaProgramacao = () => {
  const [programacaoState] = useProgramacao()
  const handleGoBack = useDefaultGoBack()

  const [loadingIntegracao, setLoadingIntegracao] = useState(false)

  const getDestino = (lote: LoteProgramacaoSnapshot) => {
    if (lote.LoteProgramacaoDestinoSnapshot.length === 0) {
      return 'Não informado'
    }

    if (lote.LoteProgramacaoDestinoSnapshot.length > 1) {
      return 'Múltiplos'
    }

    return `${lote.LoteProgramacaoDestinoSnapshot[0].cidadeDestino} / ${lote.LoteProgramacaoDestinoSnapshot[0].siglaEstadoDestino}`
  }

  const handleIntegrarRodopar = async () => {
    if (programacaoState.tag !== 'with-data') return

    try {
      setLoadingIntegracao(true)

      const response: any = await apiSauceInstance.post(
        `/programacoes/${programacaoState.entity.id}/re-integrar`
      )

      if (!response.ok) {
        const mensagemErro =
          response.data?.message ||
          `Erro no servidor (${response.problem} - Código ${response.status})`

        snackbarStore.setMessage(mensagemErro)
        return
      }

      const resultado = response.data

      if (resultado?.statusIntegracao === 'INTEGRADO') {
        snackbarStore.setMessage('Integração feita com sucesso!')
        window.location.reload()
      } else if (resultado?.statusIntegracao === 'ERRO') {
        snackbarStore.setMessage(
          'A re-integração foi executada, mas a Rodopar ainda retornou erro em algum lote.'
        )
      }
    } catch (error: any) {
      snackbarStore.setMessage(
        'Falha crítica interna no navegador ao tentar processar.'
      )
    } finally {
      setLoadingIntegracao(false)
    }
  }

  const exibirBotaoIntegrar =
    programacaoState.tag === 'with-data' &&
    programacaoState.entity.statusIntegracao !== 'INTEGRADO'

  return (
    <Grid item xs={12}>
      {programacaoState.tag === 'with-data' ? (
        <Grid container spacing={3}>
          <Grid item xs={6}>
            <Typography variant="h5" style={{ fontWeight: 'bold' }}>
              Dados da Programação
            </Typography>
          </Grid>
          <Grid item container xs={6} justifyContent="flex-end">
            <AutorizacaoCarregamento lotes={programacaoState.entity.Lotes} />
          </Grid>
          <Grid item xs={12} md={3}>
            <ConsultaField
              title="CENTRO DE CUSTO"
              subtitle={programacaoState.entity.CentroCusto?.descricao}
            />
          </Grid>
          <Grid item xs={12} md={3}>
            <Box
              onClick={() => {
                historicoIntegracaoStore.setProgramacaoId(
                  programacaoState.entity.id
                )
                historicoIntegracaoStore.openModalHistorico()
              }}
              style={{ cursor: 'pointer' }}
            >
              <ConsultaField
                title="STATUS INTEGRAÇÃO RODOPAR"
                subtitle={programacaoState.entity.statusIntegracao || 'N/A'}
              />
            </Box>
          </Grid>
          <Grid item xs={12} md={3}>
            <ConsultaField
              title="EMBARCADOR"
              subtitle={
                programacaoState.entity.embarcador
                  ? formatUsername(programacaoState.entity.embarcador)
                  : 'N/A'
              }
            />
          </Grid>
          <Grid item xs={12} md={3}>
            <ConsultaField
              title="DATA DE CARREGAMENTO"
              subtitle={`${formatDate(
                programacaoState.entity.dataCarregamento
              )} ${formatTime(programacaoState.entity.horaCarregamento)}`}
            />
          </Grid>
          <Grid item xs={12} md={3}>
            <ConsultaField
              title="DATA DE DESCARREGAMENTO"
              subtitle={`${formatDate(
                programacaoState.entity.dataDescarregamento
              )} ${formatTime(programacaoState.entity.horaDescarregamento)}`}
            />
          </Grid>
          <Grid item xs={12} md={3}>
            <ConsultaField
              title="NOME DO RESPONSÁVEL"
              subtitle={programacaoState.entity.nomeResponsavel || 'N/A'}
            />
          </Grid>
          <Grid item xs={12} md={3}>
            <ConsultaField
              title="TELEFONE DO RESPONSÁVEL"
              subtitle={programacaoState.entity.telefoneResponsavel || 'N/A'}
            />
          </Grid>
          <Grid item xs={12} md={3}>
            <ConsultaField
              title="CRIADO POR"
              subtitle={
                programacaoState.entity.emailCriador
                  ? formatUsername(programacaoState.entity.emailCriador)
                  : 'N/A'
              }
            />
          </Grid>
          <Grid item xs={12} md={3}>
            <ConsultaField
              title="Categoria"
              subtitle={
                programacaoState.entity.categoriaTransportador
                  ? formatCategoriaTransportador(
                      programacaoState.entity.categoriaTransportador
                    )
                  : 'N/A'
              }
            />
          </Grid>

          <ModalHistoricoIntegracao
            programacaoId={programacaoState.entity.id}
          />

          <Grid item xs={12}>
            <Typography variant="h5" style={{ fontWeight: 'bold' }}>
              Dados dos Lotes
            </Typography>
          </Grid>
          <Grid item xs={12}>
            {programacaoState.entity.LoteProgramacaoSnapshot.map(loteSnap => {
              const loteToProgramacao =
                programacaoState.entity.LoteToProgramacao.filter(
                  ltp => ltp.loteId === loteSnap.loteId
                )

              const lote = programacaoState.entity.Lotes.find(
                lote => lote.id === loteSnap.loteId
              )

              if (!lote) return null

              return (
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <Typography variant="h6" style={{ fontWeight: 'bold' }}>
                      Lote {lote.codigo}
                    </Typography>
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <ConsultaField
                      title="CENTRO DE CUSTO"
                      subtitle={loteSnap.centroCustoDescricao}
                    />
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <ConsultaField
                      title="DATA INICIAL DE RETIRADA"
                      subtitle={formatDate(lote.dataInicio)}
                    />
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <ConsultaField
                      title="DATA LIMITE DE RETIRADA"
                      subtitle={formatDate(lote.dataTermino)}
                    />
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <ConsultaField
                      title="PRODUTO"
                      subtitle={loteSnap.produtoNome || 'Não Informado'}
                    />
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <ConsultaField
                      title="ORIGEM"
                      subtitle={`${loteSnap.cidadeOrigem} / ${loteSnap.siglaEstadoOrigem}`}
                    />
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <ConsultaField
                      title="DESTINO"
                      subtitle={getDestino(loteSnap)}
                    />
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <ConsultaField
                      title="QUANTIDADE PREVISTA"
                      subtitle={loteToProgramacao
                        .reduce((acc, curr) => acc + curr.quantidadePrevista, 0)
                        .toLocaleString('pt-br')}
                    />
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <ConsultaField
                      title="VALOR FRETE ACORDADO"
                      subtitle={formatCurrency(
                        loteToProgramacao.reduce(
                          (acc, curr) => acc + curr.valorFreteAcordado,
                          0
                        )
                      )}
                    />
                  </Grid>
                  {loteSnap.tipoContratacao === TipoContratacao.SPOT ? (
                    <Grid item xs={12} md={3}>
                      <ConsultaField
                        title="FRETE EMPRESA"
                        subtitle={formatCurrency(
                          loteToProgramacao.reduce(
                            (acc, curr) => acc + curr.freteEmpresa,
                            0
                          )
                        )}
                      />
                    </Grid>
                  ) : null}
                  <Grid item xs={12}>
                    <Spacer />
                  </Grid>
                </Grid>
              )
            })}
          </Grid>

          <Grid item xs={12}>
            <Typography variant="h5" style={{ fontWeight: 'bold' }}>
              Dados da Composição
            </Typography>
          </Grid>
          <Grid item xs={12} md={3}>
            <ConsultaField
              title="MOTORISTA"
              subtitle={programacaoState.entity.motorista.toUpperCase()}
            />
          </Grid>
          <Grid item xs={12} md={3}>
            <ConsultaField
              title="CPF DO MOTORISTA"
              subtitle={programacaoState.entity.cpfMotorista}
            />
          </Grid>
          <Grid item xs={12} md={3}>
            <ConsultaField
              title="TELEFONE DO MOTORISTA"
              subtitle={programacaoState.entity.telefoneMotorista || 'N/A'}
            />
          </Grid>
          <Grid item xs={12} md={3}>
            <ConsultaField
              title="CAPACIDADE DE CARGA"
              subtitle={programacaoState.entity.capacidadeCargaVeiculo}
            />
          </Grid>

          <Grid item xs={12} md={3}>
            <ConsultaField
              title="PLACA PRINCIPAL"
              subtitle={programacaoState.entity.placaPrincipal}
            />
          </Grid>
          <Grid item xs={12} md={3}>
            <ConsultaField
              title="PLACA OPCIONAL (1)"
              subtitle={
                programacaoState.entity.placa_1
                  ? programacaoState.entity.placa_1
                  : 'N/A'
              }
            />
          </Grid>
          <Grid item xs={12} md={3}>
            <ConsultaField
              title="PLACA OPCIONAL (2)"
              subtitle={
                programacaoState.entity.placa_2
                  ? programacaoState.entity.placa_2
                  : 'N/A'
              }
            />
          </Grid>

          <Grid item xs={12} md={3}>
            <ConsultaField
              title="PLACA OPCIONAL (3)"
              subtitle={
                programacaoState.entity.placa_3
                  ? programacaoState.entity.placa_3
                  : 'N/A'
              }
            />
          </Grid>

          <Grid item xs={12}>
            <Typography variant="h5" style={{ fontWeight: 'bold' }}>
              Dados Adicionais
            </Typography>
          </Grid>

          <Grid item xs={12} md={3}>
            <ConsultaField
              title="OBSERVAÇÕES"
              subtitle={
                programacaoState.entity.observacoes
                  ? programacaoState.entity.observacoes
                  : 'N/A'
              }
            />
          </Grid>
          <Grid item xs={12} md={3}>
            <ConsultaField
              title="TIPO DE PAGAMENTO"
              subtitle={
                programacaoState.entity.tipoPagamento
                  ? formatEnumFromDB(programacaoState.entity.tipoPagamento)
                  : 'N/A'
              }
            />
          </Grid>
          <Grid item xs={12} md={3}>
            <ConsultaField
              title="NÚMERO DO CARTÃO"
              subtitle={programacaoState.entity.numeroCartao || 'N/A'}
            />
          </Grid>
        </Grid>
      ) : null}

      <Grid
        justifyContent="flex-end"
        item
        container
        spacing={4}
        style={{ marginTop: 8 }}
      >
        <Grid item xs={12}>
          <Grid justifyContent="flex-end" container spacing={2}>
            <Grid item style={{ width: 160 }}>
              <Button
                fullWidth
                type="button"
                variant="outlined"
                onClick={handleGoBack}
              >
                Voltar
              </Button>
            </Grid>
            {exibirBotaoIntegrar && (
              <Grid item>
                <Button
                  fullWidth
                  type="button"
                  variant="contained"
                  color="primary"
                  onClick={handleIntegrarRodopar}
                  disabled={loadingIntegracao}
                  startIcon={
                    loadingIntegracao ? (
                      <CircularProgress size={20} color="inherit" />
                    ) : null
                  }
                >
                  {loadingIntegracao ? 'Integrando...' : 'Integrar Rodopar'}
                </Button>
              </Grid>
            )}
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  )
}
